<script>

import PageHeader from "../../../components/page-header";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import DropzonePopup from '../../../components/widgets/dropzone-popup';
import { error_message,  success_message, get_user } from "../../../Helper/helper";
import {
    required,
    email,
    numeric
} from "vuelidate/lib/validators";
import { driverService, userService } from '../../../services';
import { routes } from '../../../config/api_routes';


export default {
    components: { PageHeader, VueGoogleAutocomplete,DropzonePopup},
    data() {
        return {
            
            title: 'DRIVER DETAILS',
            value: null,
            value1: null,
            zones:[],
            disable:false,
            country_code : "+49",
            driver: {
                firstname: "",
                lastname: "",
                email: "",
                contactno: "",
                alternate_contactno: "",
                frenchise_id: "",
                address: "",
                firstname_other_lang: "",
                lastname_other_lang: "",
                profileimage: "",
                city: "",
                state: "",
                customer_type: "",
                zip_code: "",
                country: "",
                latitude:"",
                longitude: "",
                driverid: "",
                availbility_status: "",
                is_block: "",
            },
            profile_image : "",
            driver_media_path: "",
            driver_licences: [],
            driver_documents: [],
            profile_delete_url: routes.driverProfileDeleteUrl,
            document_delete_url: routes.driverDocumentDeleteUrl,
            licence_delete_url: routes.driverLicenceDeleteUrl,
            deliveryZoneEmit: ''
        };
    },
    validations: {
        driver: {
            firstname: {
                required
            },
            firstname_other_lang: {
                required
            },
            lastname: {
                required
            },
            lastname_other_lang: {
                required
            },
            email: {
                required,
                email
            },
            contactno: {
                required,
                numeric
            },
            address: {
                required
            },
            username: {
                required
            },
            alternate_contactno: {
                required,
                numeric
            },
            customer_type: {
                required
            },
        }
    },
    mounted(){
        this.getDriverInfo();
        this.getFrenchise();
        this.$refs.address.focus();
        this.vendor_id = get_user().vendor_id || 40818;
    },
    computed: {
        availabilityStatus: {
            get() {
                return this.driver.is_block === '1' ? '0' : this.driver.availbility_status;
            },
            set(value) {
                this.driver.availbility_status = value;
            }
        }
    },
    methods: {
        onProfiledeleted(value){
            this.profile_image = ""
        },
        onDocumentDeleted(value) {
            console.log(value)
            this.driver_documents = this.driver_documents.filter(doc => doc.document_name !== value);
        },
        userCheckEmail(e) {
            userService.userCheckEmail({
                email:this.driver.email,
                driverid:this.driver.driverid,
                table:'User',
                column:'driverid',
                vendor_id:this.vendor_id,
                user_role:'3',
                table_name:'Driver'
            })
            .then(response => {
                if (response.data.code === 101) {
                this.disable = true;
                    error_message(response.data.message);
                }else{
                    this.disable = false;
                }
            });
        },
        getAddressData: function (addressData, placeResultData, id) {
            this.address = addressData;
            this.driver.address = placeResultData.formatted_address;
            this.driver.city = addressData.locality;
            this.driver.state = addressData.administrative_area_level_1;
            this.driver.country = addressData.country;
            this.driver.latitude = addressData.latitude;
            this.driver.longitude = addressData.longitude;
            this.driver.zip_code = addressData.postal_code;
        },
        getVehicle(){
          this.vehichleName = JSON.parse(this.$auth.setting.vehicle_name);
        },
        getDriverInfo(){
            driverService.getDriverInfo({driver_id: this.$route.params.driver_id})
            .then(response => {
                const {
                    firstname, 
                    lastname,
                    email,
                    contactno,
                    alternate_contactno,
                    frenchise_id,
                    address,
                    firstname_other_lang,
                    lastname_other_lang,
                    profileimage,
                    city,
                    state,
                    zip_code,
                    country,
                    latitude,
                    longitude,
                    driverid,
                    availbility_status,
                    username,
                    customer_type,
                    is_block
                } = response.data.result;
                this.driverid = response.data.result.driverid;
                this.driver_media_path = response.data.result.driver_media_path;
                this.profile_image = response.data.result.profileimage;
                this.profile_path = response.data.result.profile_path;
                this.driver = {
                    firstname, 
                    lastname,
                    email,
                    contactno,
                    alternate_contactno,
                    frenchise_id,
                    address,
                    firstname_other_lang,
                    lastname_other_lang,
                    city,
                    state,
                    zip_code,
                    country,
                    latitude,
                    longitude, 
                    driverid,
                    profileimage: "",
                    availbility_status,
                    username,
                    customer_type,
                    is_block
                }
                //this.deliveryZoneEmit = this.driver.frenchise_id;
                //this.$emit("deliveryZoneEmitchanged", this.deliveryZoneEmit);
            });
        },
        getFrenchise(){
            driverService.getFrenchise()
            .then(response => {
                this.zones =  response.data.result;
            });
        },
        typeForm(e) {
            this.$v.$touch();
            if (this.$v.driver.$invalid) {
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
                    }, 500, function() {
                        $(".is-invalid:first").focus();
                    });
                },500);
                return;
            }
            else{
                //this.deliveryZoneEmit = this.driver.frenchise_id;
                //this.$emit("deliveryZoneEmitchanged", this.deliveryZoneEmit);
                this.driver = {...this.driver, country_code: this.country_code, availbility_status: this.availabilityStatus };
                driverService.updateDriveProfile(this.driver)
                .then(response => {
                    if (response.data.code === 200) {
                        this.$router.push({ name: "driver-list" });
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            } 
        },
    }
}
</script>

<template>
    <div> 
        <div class="row">
            <div class="col-12">
                <form action="#" @submit.prevent="typeForm">
                <!-- Driver Info Start -->
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{ trans.get('__JSON__.Personal Information') }} ( Profile Id :- {{ driverid }} )</h4>
                        <p class="card-title-desc"></p>

                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group" v-if="$auth.setting">
                                <label class="required">{{ trans.trans('__JSON__.First Name Primary Language',{lang: $auth.langauges[0].name}) }}</label>
                                <input id="firstname" v-model="$v.driver.firstname.$model" type="text" class="form-control" :placeholder="trans.trans('__JSON__.First Name Primary Language',{lang: $auth.langauges[0].name})" name="firstname" :class="{ 'is-invalid':$v.driver.firstname.$error }" />
                                    <div v-if="$v.driver.firstname.$error" class="invalid-feedback">
                                    <span v-if="!$v.driver.firstname.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                <label class="required">{{ trans.trans('__JSON__.Last Name Primary Language',{lang: $auth.langauges[0].name}) }}</label>
                                <input id="lastname" v-model="$v.driver.lastname.$model" type="text" class="form-control" :placeholder="trans.trans('__JSON__.Last Name Primary Language',{lang: $auth.langauges[0].name})" name="lastname" :class="{ 'is-invalid':$v.driver.lastname.$error }" />
                                    <div v-if="$v.driver.lastname.$error" class="invalid-feedback">
                                    <span v-if="!$v.driver.lastname.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6" v-if="$auth.langauges[1].name != 'No Secondary Language'">
                                <div class="form-group">
                                    <label class="required">{{ trans.trans('__JSON__.First Name Secondary Language',{lang: $auth.langauges[1].name}) }}</label>
                                    <input id="firstname_other_lang" name="firstname_other_lang" v-model="$v.driver.firstname_other_lang.$model" type="text" :placeholder="trans.trans('__JSON__.First Name Secondary Language',{lang: $auth.langauges[1].name})" class="form-control" :class="{ 'is-invalid':$v.driver.firstname_other_lang.$error }" />
                                    <div v-if="$v.driver.firstname_other_lang.$error" class="invalid-feedback">
                                    <span v-if="!$v.driver.firstname_other_lang.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                                    </div>
                                </div>
                            </div>
                        
                            <div class="col-sm-6" v-if="$auth.langauges[1].name != 'No Secondary Language'">
                                <div class="form-group">
                                <label class="required">{{ trans.trans('__JSON__.Last Name Secondary Language',{lang: $auth.langauges[1].name}) }}</label>
                                <input id="lastname_other_lang" name="lastname_other_lang" v-model="$v.driver.lastname_other_lang.$model" type="text" :placeholder="trans.trans('__JSON__.Last Name Secondary Language',{lang: $auth.langauges[1].name})" class="form-control" :class="{ 'is-invalid':$v.driver.lastname_other_lang.$error }" />
                                <div v-if="$v.driver.lastname_other_lang.$error" class="invalid-feedback">
                                    <span v-if="!$v.driver.lastname_other_lang.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                <label class="required">{{ trans.get('__JSON__.E-Mail') }}</label>
                                    <input id="email" v-model="$v.driver.email.$model" type="email" name="email" class="form-control" @blur="userCheckEmail" :class="{ 'is-invalid':$v.driver.email.$error }" :placeholder="trans.get('__JSON__.Enter Email')" />
                                    <div v-if="$v.driver.email.$error" class="invalid-feedback">
                                        <span v-if="!$v.driver.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                        <span v-if="!$v.driver.email.email">{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <label class="required">{{ trans.get('__JSON__.Primary Contact Number') }}</label>
                                <div class="no-grid">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{ country_code }}</span>
                                    </div>
                                    <input id="contactno" v-model="$v.driver.contactno.$model" type="tel" name="contactno" class="form-control" :class="{ 'is-invalid':$v.driver.contactno.$error }" :placeholder="trans.get('__JSON__.Primary contact number')" maxlength="15" minlength="11" />
                                    <div v-if="$v.driver.contactno.$error" class="invalid-feedback" style="grid-column: span 2;">
                                        <span v-if="!$v.driver.contactno.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                                        <span v-if="!$v.driver.contactno.numeric">{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <label class="required">{{ trans.get('__JSON__.Personal contact number') }}</label>
                                <div class="no-grid">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{ country_code }}</span>
                                    </div>
                                    <input type="tel" class="form-control" id="alternate_contactno" :placeholder="trans.get('__JSON__.Personal contact number')" aria-label="Username" aria-describedby="basic-addon1" v-model="driver.alternate_contactno" name="alternate_contactno" maxlength="15" minlength="11" :class="{ 'is-invalid':$v.driver.alternate_contactno.$error }">
                                    <div v-if="$v.driver.alternate_contactno.$error" class="invalid-feedback" style="grid-column: span 2;">
                                        <span v-if="!$v.driver.alternate_contactno.required">{{ trans.get('__JSON__.Please enter personal number') }}</span>
                                        <span v-if="!$v.driver.alternate_contactno.numeric">{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-md-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text text-center" id="basic-addon1">+49</span>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <input id="alternate_contactno" v-model="driver.alternate_contactno" type="tel" name="alternate_contactno" class="form-control" :placeholder="trans.get('__JSON__.Personal contact number')" maxlength="12" minlength="7" :class="{ 'is-invalid':$v.driver.alternate_contactno.$error }"/>
                                            <div v-if="$v.driver.alternate_contactno.$error" class="invalid-feedback">
                                                <span v-if="!$v.driver.alternate_contactno.required">{{ trans.get('__JSON__.Please enter personal number') }}</span>
                                                <span v-if="!$v.driver.alternate_contactno.numeric">{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="required">{{ trans.get('__JSON__.Full address') }}</label>
                                    <vue-google-autocomplete  
                                        ref="address"
                                        id="addres"
                                        name="address"
                                        type="text"
                                        class="form-control"
                                        placeholder="Please type your address"
                                        v-model="$v.driver.address.$model"
                                        v-on:placechanged="getAddressData"   
                                        :class="{'is-invalid':$v.driver.address.$error}"
                                    >
                                    </vue-google-autocomplete>
                                    <div v-if="$v.driver.address.$error" class="invalid-feedback">
                                        <span v-if="!$v.driver.address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                <label class="required">{{ trans.get('__JSON__.User Name') }}</label>
                                    <input id="username" v-model="$v.driver.username.$model" type="text" name="username" class="form-control" :class="{ 'is-invalid':$v.driver.username.$error }" :placeholder="trans.get('__JSON__.UserName')"/>
                                    <div v-if="$v.driver.username.$error" class="invalid-feedback">
                                    <span v-if="!$v.driver.username.required">{{ trans.get('__JSON__.Please enter username') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 vendor-status">
                                <b-form-group
                                    id="input-group-2"
                                    :label="trans.get('__JSON__.Status')"
                                    label-for="Status"
                                >
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="swtich-data">
                                            <label class="switch">
                                                <input
                                                type="checkbox"
                                                id="togBtn"
                                                class="switch-on"
                                                name="is_block"
                                                v-model="driver.is_block"
                                                true-value="0"
                                                false-value="1"
                                                />
                                                <div class="slider round">
                                                    <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                                    <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                                </div>
                                            </label>
                                            </div>
                                        </div>
                                    </div>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6">
                                <b-form-group
                                    id="input-group-2"
                                    :label="trans.get('__JSON__.Customer Type')"
                                    label-for="Customer Type"
                                >      
                                    <select
                                        v-model="driver.customer_type"
                                        class="form-control"
                                        :class="{ 'is-invalid':$v.driver.customer_type.$error }"
                                        id="customer_type"
                                    >
                                        <!-- <option value="0">Both</option> -->
                                        <option value="1">Business</option>
                                        <option value="2">Private</option>
                                    </select>
                                    <div v-if="$v.driver.customer_type.$error" class="invalid-feedback">
                                        <span v-if="!$v.driver.customer_type.required">{{ trans.get('__JSON__.Please select Customer Type') }}</span>
                                    </div>
                                </b-form-group>
                            </div>
              
                            <div class="col-sm-6">
                                <div class="form-group">
                                <label class="control-label">{{ trans.get('__JSON__.Profile Image') }}</label>
                                    <dropzone-popup
                                        v-model="driver.profileimage"
                                        id="profile_image"
                                        acceptedFiles=".jpeg,.jpg,.png"
                                        :editable-images="profile_image"
                                        :media-path="driver_media_path+'/original'"
                                        :delete-path="profile_delete_url"
                                        @image-deleted="this.onProfiledeleted"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <button type="submit" class="btn btn-primary mr-1 mt-3" :disabled="disable">{{ trans.trans('__JSON__.Update Driver', {driver: $auth.setting.driver_name }) }}</button>
                                <router-link :to="{name: 'driver-list'}" type="submit" class="btn btn-secondary mt-3">{{ trans.trans('__JSON__.Cancel') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Driver Info End -->
                </form>
            </div>
        </div>
      <!-- end row -->
    </div>
</template>
<style scoped>
.no-grid{
    display: grid;
    grid-template-columns: 50px 1fr;
}
</style>